import React from 'react';

import type { IconProps } from '@atlaskit/icon';
import { JiraIcon } from '@atlaskit/logo';

export const JiraLogoIcon = (props: IconProps) => (
	<JiraIcon {...props} appearance="brand" size="small" />
);
